import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";

export default function RowEdit({
  onHide,
  event,
  onEdit,
  setShowEditForm,
  ...rest
}) {
  const [title, setTitle] = useState(event.title);
  const [desc, setDesc] = useState(event.description);
  const [eventDate, setEventDate] = useState(event.eventDate || event.event_date);
  const [location, setLocation] = useState(event.location || '');

  return (
    <>
      <Modal onHide={onHide} {...rest}>
        <Modal.Header closeButton>
          <Modal.Title>Edit {event.title} </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <div id="labels">Event name</div>
              <Form.Control
                size="lg"
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                }}
                placeholder="Event Name"
              />
            </Form.Group>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <div id="labels">Event Description</div>
              <Form.Control
                as="textarea"
                rows={3}
                size="lg"
                value={desc}
                onChange={(e) => {
                  setDesc(e.target.value);
                }}
                placeholder="Description"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <div id="labels">Event Date</div>
              <Form.Control
                size="lg"
                type="date"
                value={eventDate}
                onChange={(e) => {
                  setEventDate(e.target.value);
                }}
                placeholder="Event Date"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <div id="labels">Location</div>
              <Form.Control
                size="lg"
                value={location}
                onChange={(e) => {
                  setLocation(e.target.value);
                }}
                placeholder="Event Location (optional)"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              let edited_event = {
                title: title,
                description: desc,
                eventDate: eventDate,
                location: location,
              };
              onEdit(edited_event, event);
              setShowEditForm(false);
            }}
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
